import { useNavigate } from 'react-router-dom'
import { useFetchDefectSegmentsQuery, useFetchRoadMeasuresQuery } from '../../../../../api/rtk/base/slices/diagnosticsApiSlice'
import type { SpecialContributor } from '../types'

export const roadDiagnosticsContributor: SpecialContributor = {
    id: 'roadDiagnostics',
    useContribute: ({ objectTypeName, objectInfo }) => {
        const navigate = useNavigate()
        const enabled = objectTypeName === 'RoadDiagnosticsSegments'
        const eventId = (objectInfo as any)?.EventID

        const { data: roadMeasures, isLoading: l1 } = useFetchRoadMeasuresQuery(
            { top: 1, pages: true, filterString: `EventId eq ${eventId}`, skip: 0, order: '' },
            { skip: !enabled || eventId == null }
        )
        const { data: defectSegments, isLoading: l2 } = useFetchDefectSegmentsQuery(
            { top: 1, pages: true, filterStringArray: [`EventID eq ${eventId}`], skip: 0, order: '' },
            { skip: !enabled || eventId == null }
        )

        return {
            extraButtonsBySection: enabled ? {
                'Участок диагностики': [
                    {
                        format: 'button',
                        type: 'action',
                        actionKey: 'diagnosticsComposition',
                        caption: `Состав диагностики (${roadMeasures?.['@xdata.count'] ?? 0})${defectSegments?.['@xdata.count'] ? ` + Дефекты (${defectSegments?.['@xdata.count']})` : ''}`,
                    }
                ]
            } : undefined,
            buttonsOptions: {
                customActions: {
                    diagnosticsComposition: {
                        isLoading: l1 || l2,
                        disabled: !(roadMeasures?.['@xdata.count'] || defectSegments?.['@xdata.count']),
                        onClick: () => navigate(`/app/diagnostics/diagnosticsSegments/${eventId}/composition`)
                    }
                }
            }
        }
    }
}


